<template>
  <section
    class="property-map"
  >
    <div
      ref="map"
      class="map"
    />
  </section>
</template>

<script>
import { isEmptyString } from 'mytribus-commons';

import tailwindConfig from '../../../../../tailwind.config';

export default {
  name: 'PropertyMap',

  display({ property }) {
    return !isEmptyString(property.location.gis.latitude)
      && !isEmptyString(property.location.gis.longitude);
  },

  props: {
    appleMapKitToken: {
      required: true,
      type: String,
    },
    branded: {
      required: true,
      type: Boolean,
    },
    property: {
      required: true,
      type: Object,
    },
  },

  mounted() {
    if (window.mapkit === undefined) {
      return;
    }

    mapkit.addEventListener('configuration-change', () => {
      const coordinate = new mapkit.Coordinate(
        parseFloat(this.property.location.gis.latitude),
        parseFloat(this.property.location.gis.longitude),
      );

      const marker = new mapkit.MarkerAnnotation(coordinate, {
        color: this.branded
          ? tailwindConfig.theme.extend.colors.secondary
          : '#888888',
      });

      const map = new mapkit.Map(this.$refs.map, {
        annotations: [
          marker,
        ],
      });

      map.setCameraDistanceAnimated(1000);

      mapkit.removeEventListener('configuration-change');
    });

    mapkit.init({
      authorizationCallback: (done) => {
        done(this.appleMapKitToken);
      },
    });
  },
};
</script>

<style lang="scss">
.property-map {

  .map {
    width: 100%;
    height: 300px;
  }

  @screen xl {

    .map {
      height: 600px;
    }
  }
}
</style>
